export var dataHooks;
(function (dataHooks) {
    dataHooks["prefixIcon"] = "prefix-icon";
    dataHooks["suffixIcon"] = "suffix-icon";
})(dataHooks || (dataHooks = {}));
//# sourceMappingURL=constants.js.map